<template>
  <div class="addPanel">
      <el-input
        placeholder="新增发票类型名称"
        clearable
        v-model="receiptType.receiptTypeName"
        :maxlength="10"
        show-word-limit></el-input>
      <el-button type="primary" :loading="loading" @click="addNewReceiptType">
        <i class="el-icon-plus"></i>&nbsp;
        新增
      </el-button
      >
  </div>
</template>
<script>
import { addType } from '@/api/receiptType'
export default {
  name: 'AddReceiptType',
  props: {
    flush: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      receiptType: {
        id: null,
        receiptTypeName: '',
        createTime: null
      },
      loading: false,
    }
  },
  mounted() {},
  methods: {
    async addNewReceiptType() {
      if (!this.receiptType.receiptTypeName || this.receiptType.receiptTypeName.length <= 0) {
        return this.$message.error('发票类型名称不能为空')
      }
      const conf = await this.$confirm('将要添加新的发票类型，请确定是否继续？', '提示', { type: 'warning' }).catch(err => err)
      if (conf !== 'confirm') {
        return this.$message.info('操作已取消')
      }
      this.loading = true
      const { data: res } = await addType(this.receiptType).catch(err => err)
      if (res) {
        this.flush()
        this.$message.success('添加成功')
        this.receiptType.receiptTypeName = ''
      }
      this.loading = false
    }
  },
}
</script>
<style scoped lang="less">
.addPanel{
  width: 100%;
  display: flex;
  justify-self: start;
  gap: 50px;
  .el-input{
    width: 250px;
  }
}
</style>
